import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row } from 'antd';
import Styles from './SearchOverlay.module.scss';
import { TSearchOverlay } from './definitions';
import { joinClassnames } from 'helpers/classNames';
import SearchBox from '../../Molecules/SearchBox';
import PopularSearch from '../../Molecules/PopularSearch';
import RecentSearch from '../../Molecules/RecentSearch';
import { useFetchSearchBannerData } from 'Pages/Home/Hooks/useFetchSearchBannerData';
import BannerSearch from '../../Molecules/BannerSearch';
import EmptySearch from '../../Molecules/EmptySearch';
import SearchItem from '../../Molecules/SearchItem';
import SearchMoreButton from '../../Molecules/SearchMoreButton';
import { useFetchSearchProductData } from 'Pages/Home/Hooks/useFetchSearchProductData';
import useDebounce from 'Pages/Home/Hooks/useDebounce';

const SearchOverlay: React.FC<TSearchOverlay> = ({
  show,
  onHide,
  userId,
  category,
}) => {
  const { data: bannerData } = useFetchSearchBannerData();
  const [isSearchMode, setIsSearchMode] = React.useState(false);
  const [isEmptySearch, setIsEmptySearch] = React.useState(false);
  const [keyword, setKeyword] = React.useState('');

  const debouncedKeyword = useDebounce(keyword, 1750);
  const { data, total, isEmpty, isFetching } = useFetchSearchProductData(
    '',
    20,
    debouncedKeyword,
  );

  React.useEffect(() => {
    setIsEmptySearch(isEmpty);
  }, [isEmpty]);

  const onAfterClick = () => {
    setKeyword('');
    setIsSearchMode(false);
    onHide();
  };

  const renderItem = () => {
    if (isEmptySearch)
      return (
        <EmptySearch
          title="Oh snap, we can’t find it!"
          text="The items you’re looking for doesn’t seem to exists in our category. Please try in another keywords."
        />
      );

    return (
      <>
        <SearchItem
          data={data}
          afterClick={onAfterClick}
          highlightText={debouncedKeyword}
        />
        <SearchMoreButton
          userId={userId}
          keyword={debouncedKeyword}
          total={total}
          afterClick={onAfterClick}
          isFetching={isFetching}
        />
      </>
    );
  };

  const renderContent = () => {
    if (isSearchMode) {
      return renderItem();
    }
    return (
      <>
        <PopularSearch
          afterClick={onAfterClick}
          category={category}
          userId={userId}
        />
        <RecentSearch
          title="Recent Search"
          rightTitle="Clear All"
          afterClick={onAfterClick}
          userId={userId}
        />
        <BannerSearch bannerData={bannerData} />
      </>
    );
  };

  return (
    <Row
      justify="start"
      align="middle"
      className={joinClassnames(
        Styles['search-header-row'],
        !show && Styles['hide'],
      )}
    >
      <Row
        justify={document.body.clientWidth > 1018 ? 'space-between' : 'start'}
        align="middle"
        className={Styles['search-overlay-wrapper']}
      >
        <SearchBox
          onClick={onAfterClick}
          isForm
          show={show}
          setSearchMode={setIsSearchMode}
          setSearchKeyword={setKeyword}
          userId={userId}
          keyword={keyword}
        />
        {renderContent()}
      </Row>
    </Row>
  );
};

export default SearchOverlay;
